import api from "./api";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
}

export async function isPushSupported() {
    return typeof window !== "undefined"
        && "serviceWorker" in navigator
        && "PushManager" in window
        && "Notification" in window;
}

export async function getPushStatus() {
    if (!(await isPushSupported())) return "unsupported";
    if (Notification.permission === "denied") return "denied";
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return "unregistered";
    const sub = await reg.pushManager.getSubscription();
    return sub ? "subscribed" : "unsubscribed";
}

export async function enablePush() {
    if (!(await isPushSupported())) throw new Error("Push not supported on this browser");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Permission denied");
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    if (!data.key) throw new Error("Push not configured on server");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(data.key),
        });
    }
    await api.post("/push/subscribe", { subscription: sub.toJSON() });
    return true;
}

export async function disablePush() {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
        await sub.unsubscribe();
    }
}
